var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('svg',{attrs:{"width":_vm.size,"height":_vm.size,"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M20 2H4c-1.103 0-2 .897-2 2v18l4-4h14c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zm-7 \n        13h-2v-2h2v2zm0-4h-2V5h2v6z"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }